import React, { useRef, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { createAnnonce } from "../../actions/annonce.action";
import { FaCar } from "react-icons/fa";
import { toast, ToastContainer } from "react-toastify";
import PaiementModal from "./AnnoncesInformations";
import { CATEGORIES } from "../categorie.constant";

const VehiculeForm = ({ utilisateurId }) => {
  const VEHICULE_CATEGORIE_ID = CATEGORIES.find(
    (cat) => cat.label === "Véhicule et engins"
  )?.id;

  const dispatch = useDispatch();

  const fileInputRef = useRef(null);

  const [modalIsOpen, setModalIsOpen] = useState(false);

  useEffect(() => {
    setModalIsOpen(true);
  }, []);

  const utilisateur = useSelector((state) => state.user);

  const [formData, setFormData] = useState({
    titre: "",
    description: "",
    prix: "",
    transaction: "",
    carburant: "",
    chevaux: "",
    modele: "",
    kilometrage: "",
    annee: "",
    typeVehicule: "",
    images: [],
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setFormData((prev) => ({ ...prev, images: e.target.files }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});

    const dataToSend = new FormData();
    dataToSend.append("categorieId", VEHICULE_CATEGORIE_ID);
    dataToSend.append("utilisateur", utilisateurId);
    Object.keys(formData).forEach((key) => {
      if (key === "images") {
        for (let i = 0; i < formData.images.length; i++) {
          dataToSend.append("images", formData.images[i]);
        }
      } else {
        dataToSend.append(key, formData[key]);
      }
    });

    try {
      const response = await dispatch(createAnnonce(dataToSend));

      if (
        response &&
        typeof response === "object" &&
        Object.keys(response.errors || {}).length > 0
      ) {
        console.log("Erreurs reçues :", response.errors);
        setErrors(response.errors);
      } else {
        setFormData({
          titre: "",
          description: "",
          prix: "",
          transaction: "",
          carburant: "",
          chevaux: "",
          modele: "",
          kilometrage: "",
          annee: "",
          typeVehicule: "",
          images: [],
        });

        if (fileInputRef.current) {
          fileInputRef.current.value = null;
        }

        setErrors({});
        toast.success(
          "Félicitations, votre annonce a bien été créée ! Elle sera soumise à la validation de l'administrateur."
        );
      }
    } catch (err) {
      console.error("Erreur lors de la soumission du formulaire :", err);
    }
  };

  return (
    <>
      <form className="AnnonceForm" onSubmit={handleSubmit}>
        <FaCar />
        <h2>Créer une annonce pour un véhicule :</h2>

        {errors.titre && (
          <span className="error">Votre annonce doit avoir un titre</span>
        )}
        <input
          type="text"
          name="titre"
          placeholder="Titre"
          onChange={handleChange}
          value={formData.titre}
        />

        {errors.description && (
          <span className="error">
            Veuillez donner une description pour votre annonce
          </span>
        )}
        <textarea
          name="description"
          placeholder="Description"
          onChange={handleChange}
          value={formData.description}
        />

        {errors.transaction && (
          <span className="error">
            Veuillez renseigner le type de transaction
          </span>
        )}
        <select
          name="transaction"
          onChange={handleChange}
          value={formData.transaction}
        >
          <option value="">Type de transaction</option>
          <option value="Location">Location</option>
          <option value="Achat">Achat</option>
        </select>

        <div className="priceDiv">
          <input
            type="number"
            name="prix"
            placeholder="Prix"
            onChange={handleChange}
            value={formData.prix}
          />
          <label>FCFA</label>
        </div>

        <input
          type="text"
          name="modele"
          placeholder="Modèle"
          onChange={handleChange}
          value={formData.modele}
        />
        <input
          type="number"
          name="kilometrage"
          placeholder="Kilométrage"
          onChange={handleChange}
          value={formData.kilometrage}
        />
        {errors.chevaux && (
          <span className="error">
            Le nombre de chevaux du véhicule est obligatoire
          </span>
        )}
        <input
          type="number"
          name="chevaux"
          placeholder="Nombre de chevaux"
          onChange={handleChange}
          value={formData.chevaux}
        />

        <select
          name="carburant"
          onChange={handleChange}
          value={formData.carburant}
        >
          <option value="" disabled hidden>
            Type de carburant
          </option>
          <option value="Essence">Essence</option>
          <option value="Diesel">Diesel</option>
        </select>

        {errors.annee && (
          <span className="error">L'année du véhicule est obligatoire</span>
        )}
        <input
          type="number"
          name="annee"
          placeholder="Année"
          onChange={handleChange}
          value={formData.annee}
        />

        <select
          name="typeVehicule"
          onChange={handleChange}
          value={formData.typeVehicule}
        >
          <option value="" disabled hidden>
            Type de véhicule
          </option>
          <option value="Tourisme">Tourisme</option>
          <option value="Utilitaires">Utilitaires</option>
          <option value="Engins de levage">Engins de levage</option>
          <option value="Engins de terrassement">Engins de terrassement</option>
          <option value="2 roues">2 roues</option>
          <option value="Tricycle">Tricycle</option>
        </select>

        <input
          type="file"
          name="images"
          multiple
          onChange={handleFileChange}
          ref={fileInputRef}
        />
        {errors.images && <span className="error">{errors.images}</span>}

        <button className="button" type="submit">
          Créer l'annonce
        </button>
        {formData.transaction === "Achat" ? (
          <span>Prix de l'annonce : 2000 Francs CFA</span>
        ) : (
          <span>Prix de l'annonce : 1000 Francs CFA</span>
        )}
        <span>Paiement par Orange Money au 07-04-64-27-18</span>
      </form>
      <PaiementModal
        isOpen={modalIsOpen}
        onClose={() => setModalIsOpen(false)}
      />
      <ToastContainer position="top-right" autoClose={5000} />
    </>
  );
};

export default VehiculeForm;
